import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

interface Props {
  align?: 'left' | 'center' | 'right';
  containerWidth?: string | number;
  containerHeight?: string | number;
  containerMargin?: string | number;
  className?: string;
  direction?: 'row' | 'column';
  justify?:
    | 'top'
    | 'center'
    | 'bottom'
    | 'space-evenly'
    | 'space-around'
    | 'space-between';
  rounded?: boolean | undefined;
  rowHeight?: string | number | undefined;
  loading?: boolean;
  skeletons: string[] | number[];
  spacing?: number | undefined;
}

const alignment = (align: string | undefined) => {
  switch (align) {
    case undefined:
      return undefined;
    case 'left':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
  }
};

const justification = (justify: string | undefined) => {
  switch (justify) {
    case undefined:
      return undefined;
    case 'top':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'bottom':
      return 'flex-end';
    case justify?.includes('space-'):
      return justify;
  }
};
export const DynamicSkeleton = ({
  align,
  containerWidth,
  containerHeight,
  containerMargin,
  className,
  direction,
  justify,
  loading,
  rounded,
  rowHeight,
  skeletons,
  spacing,
  ...rest
}: Props) => {
  const classes = useStyles(
    alignment(align) ?? 'flex-start',
    containerWidth ?? '100%',
    containerHeight ?? '100%',
    containerMargin ?? 10,
    direction ?? 'row',
    justification(justify) ?? 'center',
    spacing ?? 0
  )();

  if (loading !== undefined && !loading) return null;

  return (
    <div className={clsx(classes.container, className)}>
      {skeletons.map((skeletonWidth: string | number, index: number) => {
        return (
          <Skeleton
            key={`skeleton-${index}`}
            className={clsx({ [classes.rounded]: rounded })}
            style={{ width: skeletonWidth, height: rowHeight ?? 20 }}
            {...rest}
          />
        );
      })}
    </div>
  );
};

const useStyles = (
  align: string,
  containerWidth: string | number,
  containerHeight: string | number,
  containerMargin: string | number,
  direction: 'row' | 'column',
  justify: string,
  spacing: number
) =>
  makeStyles((theme) => ({
    container: {
      display: 'flex',
      flexDirection: direction,
      alignItems: align,
      justifyContent: justify,
      width: containerWidth,
      height: containerHeight,
      padding: containerMargin,
      gap: theme.spacing(spacing),
    },
    rounded: {
      borderRadius: 30,
    },
  }));
